<template>
  <TabelaOSD
    :colunas="resolvedColumns"
    :linhas="table.rows"
    :carregando="table.isLoading"
    :total-linhas="table.totalRows"
    :pagina="pagination.page"
    :campo-ordenacao="pagination.sort"
    :ordem-ordenacao="pagination.order"
    :texto-tabela-vazia="$t('indicadoresNaoEncontrados')"
    @page-change="onPageChange"
    @sort-change="onSortChange"
    @reload="getAdmin"
  >
    <template #toolbar-actions>
      <ComissaoExport v-bind="pagination" :headers="headers" />
    </template>
    <template #toolbar-filters>
      <ComissaoFilters :loading="table.isLoading" @filter="onFilter" />
    </template>
    <template #cell-pagamento="props">
      <span v-if="!props.linha.pagamento">
        <a
          class="btn btn-info mx-1" :title="$t('pagar')"
          @click="pagarComissao(props.linha.idCodigo, parseInt(props.linha.renovacoes))"
        >
          {{ $t('pagar') }}
        </a>
      </span>
      <span v-else>
        {{ $t('pago') }}
      </span>
    </template>
  </TabelaOSD>
  <PagarComissaoModal ref="pagarComissaoModal" v-bind="selected" @update-table="getAdmin" />
</template>

<script>
import ComissaoExport from './ComissaoExport.vue';
import ComissaoFilters from './ComissaoFilters.vue';
import TabelaOSD from '@/modules/shared/components/tabelaOSD/TabelaOSD.vue';
import { getPaginatedComissaoData } from '../comissaoService';
import { useToast } from 'vue-toastification';
import { toDate } from '@/modules/core/utils/formats';
import { i18n } from '@/modules/localization';
import { ref, computed } from 'vue';
import PagarComissaoModal from './PagarComissaoModal.vue';

export default {
  components: { ComissaoExport, ComissaoFilters, TabelaOSD, PagarComissaoModal },
  data: () => ({
    selected: {
      id: '',
      renovacoes: 0,
    },
    table: {
      totalRows: 0,
      rows: [],
      columns: ref([
        {
          label: computed((_) => i18n.global.t('empresa')),
          field: 'empresa',
        }, {
          label: computed((_) => i18n.global.t('documento')),
          field: 'documento',
        }, {
          label: computed((_) => i18n.global.t('dataCadastro')),
          field: 'dataCadastro',
          tdClass: 'text-break',
          formatFn: toDate,
        }, {
          label: computed((_) => i18n.global.t('parceiro', 1)),
          field: 'parceiro',
        }, {
          label: computed((_) => i18n.global.t('renovacoes')),
          field: 'renovacoes',
        }, {
          label: computed((_) => i18n.global.t('tipoAssinatura')),
          field: 'tipoAssinatura',
        }, {
          label: computed((_) => i18n.global.t('pagamento')),
          field: 'pagamento',
        },

      ]),
      mode: 'remote',
      class: 'osd-table',
      styleClass: 'vgt-table bordered condensed',
      compactMode: true,
      lineNumbers: true,
      paginationOptions: {
        enabled: true,
        mode: 'pages',
        perPageDropdownEnabled: false,
        nextLabel: '>',
        prevLabel: '<',
        infoFn: (params) => `
      ${params.firstRecordOnPage} - ${params.lastRecordOnPage} de ${params.totalRecords}
      `,
      },
      sortOptions: {
        enabled: true,
        initialSortBy: { field: 'dataCadastro', type: 'desc' },
      },
      isLoading: false,
    },
    pagination: {
      page: 1,
      sort: 'dataCadastro',
      order: 'desc',
      search: '',
    },
    pagamento: '',
  }),
  computed: {
    resolvedColumns() {
      return this.table.columns.map((column) => ({
        ...column,
        label: column.label?.value ?? column.label,
      }));
    },
    headers() { return this.resolvedColumns.map((column) => column.label); },
  },
  methods: {
    pagarComissao(id, renovacoes) {
      this.selected.id = id;
      this.selected.renovacoes = renovacoes;
      this.$refs.pagarComissaoModal.show();
    },
    updateParams(pagination) {
      this.pagination = { ...this.pagination, ...pagination };
    },
    onPageChange(page) {
      this.updateParams({ page });
      this.getAdmin();
    },
    onSortChange(field) {
      const nextOrder = this.pagination.sort === field && this.pagination.order === 'asc' ? 'desc' : 'asc';
      this.updateParams({
        page: 1,
        sort: field,
        order: nextOrder,
      });
      this.getAdmin();
    },
    onFilter(filters) {
      this.updateParams({ ...filters, page: 1 });
      this.getAdmin();
    },
    async getAdmin() {
      this.table.isLoading = true;
      try {
        const data = await getPaginatedComissaoData(this.pagination);
        this.table.rows = data.dados;
        this.table.totalRows = data.total;
      } catch (error) {
        useToast().error(this.$t('erroAoObterDashboard'));
      }
      this.table.isLoading = false;
    },
  },
};

</script>
